import router from "../router";
import store from "../store";
import { Message } from "element-ui";
import { getAdminList } from "@/api/htxx/htxx";
import { getToken, removeToken, setTokenByArg } from "@/utils/auth";
import { IEVersion } from "@/utils/validate.js";

const whiteList = ["/login", "/sso/logout"];
let num = 0;

router.beforeEach((to, from, next) => {
  let IEV = IEVersion();
  if (IEV > 0 && IEV < 10) {
    Message.error("当前IE浏览器版本较低，请升级到IE10及以上浏览器访问系统。");
    return;
  }
  let search = window.location.search.split("?");
  if (search.length == 2) {
    //统一登录用户 去除token从新登录
    let arr = search[1].split("&");
    if (arr.some(a => a.split("=")[0] == "code")) {
      if (num == 0) {
        removeToken();
      }
    }
  }
  if (getToken()) {
    if (to.path === "/login") {
      next({
        path: "/"
      });
    } else if (to.path === "/sso/logout") {
      next();
    } else if (store.getters.navBar.length === 0) {
      store
        .dispatch("GetUserInfo")
        .then(res => {
          store.dispatch("GetNav", res).then(() => {
            if (window.location.search) {
              window.location.href = window.location.href.replace(
                window.location.search,
                ""
              );
            }
            store.dispatch("queryAllConfig").then(res => {
              next()
            }).catch(err => {
              next();
            })
          });
        })
        .catch(() => {
          store.dispatch("LogOut").then(() => {
            Message.error("验证失败, 请重新登录");
            next({
              path: "/login"
            });
          });
        });
    } else if (to.path.substring(0, 15) === "/zxManage/zxlm_") {
      next({
        path: "/zxManage"
      });
    } else {
      next();
    }
  } else {
    let search = window.location.search.split("?");
    if (whiteList.indexOf(to.path) !== -1) {
      if (window.pageOption == "no") {
        //是否允许单独登录银农直连
        if (to.path == "/login") {
          next("/404");
        }
      } else {
        next();
      }
    } else if (search.length == 2) {
      let obj = {};
      let arr = search[1].split("&");
      //统一登录-code登录
      if (arr.some(a => a.split("=")[0] == "code")) {
        if (arr.length > 1) {
          //新版统一登录新增加了callbackurl
          // obj.callbackurl = arr[1].split("=")[1];
          window.sessionStorage.setItem(
            "tydlUrl",
            arr[arr.length - 1].split("=")[1]
          );
        } else {
          window.sessionStorage.setItem("tydlUrl", "");
        }
        obj.code = arr[0].split("=")[1];
        getAdminList({
          pageNo: 1,
          pageSize: 10
        }).then(res => {
          let data = res.data;
          if (data.success) {
            if (!data.msg.data[0].t9) {
              data.msg.data[0].t9 = "0";
            }
            window.sessionStorage.setItem(
              "userLogo",
              JSON.stringify(data.msg.data[0])
            );
            store
              .dispatch("loginByCode", obj)
              .then(() => {
                //统一登录只登陆一次
                setTokenByArg("sso-token-test", "0");
                window.sessionStorage.setItem("payPassword", "");
                num++;
                router.push({
                  path: "/"
                });
              })
              .catch(() => {
                Message.error("登录失败");
              });
          }
        });
      } else if (arr.some(a => a.split("=")[0] == "name")) {
        //统一登录-用户名密码登录
        obj.username = arr
          .filter(a => a.split("=")[0] == "name")[0]
          .split("=")[1];
        obj.password = arr
          .filter(a => a.split("=")[0] == "passwd")[0]
          .split("=")[1];
        store
          .dispatch("LoginByUsername", obj)
          .then(() => {
            router.push({
              path: "/"
            });
          })
          .catch(() => {
            Message.error("登录失败");
          });
      }
    } else if (window.pageOption == "no") {
      if (to.path == "/404") {
        next();
      } else {
        next({
          path: "/login"
        });
      }
    } else if (
      JSON.parse(window.sessionStorage.getItem("ssoUsername")) &&
      JSON.parse(window.sessionStorage.getItem("ssoUsername")).ssoUsername
    ) {
      if (window.sessionStorage.getItem("tydlUrl")) {
        window.location.href = window.sessionStorage.getItem("tydlUrl");
      } else {
        window.location.href = JSON.parse(
          window.sessionStorage.getItem("userLogo")
        ).xturllb;
      }
    } else {
      next("/login");
    }
  }
});
router.onError(error => {
  console.log(error);
  // alert(1)
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
